import React, { useState } from 'react';
import BibliothequePlotly from '../../Graphe/AffichageGraphe/BibliothequePlotly/BibliothequePlotly';
import { mockCapteurs } from '../mockDonnees';
import S from '../GestionDonnees.module.scss';

const VisualisationTab = ({ capteurActif, setCapteurActif, donnees, onMettreAJour }) => {
    const [editId, setEditId] = useState(null);
    const [editValues, setEditValues] = useState({});

    const capteurInfo = mockCapteurs.find((c) => c.id === capteurActif) || mockCapteurs[0];

    const startEdit = (d) => {
        setEditId(d.id);
        setEditValues({
            valeur_brute: d.valeur_brute,
            valeur_corrigee: d.valeur_corrigee,
            commentaire: d.commentaire,
        });
    };

    const cancelEdit = () => {
        setEditId(null);
        setEditValues({});
    };

    const saveEdit = (id) => {
        const brute = parseFloat(editValues.valeur_brute);
        const corr = parseFloat(editValues.valeur_corrigee);
        if (isNaN(brute) || isNaN(corr)) return;
        onMettreAJour(
            donnees.map((d) =>
                d.id === id
                    ? {
                        ...d,
                        valeur_brute: brute,
                        valeur_corrigee: corr,
                        commentaire: editValues.commentaire,
                        statut: 'ok',
                        anomalie: false,
                    }
                    : d
            )
        );
        cancelEdit();
    };

    const dates = donnees.map((d) => d.date);

    const plotData = [
        {
            x: dates,
            y: donnees.map((d) => d.valeur_brute),
            type: 'scatter',
            mode: 'lines+markers',
            name: 'Valeurs brutes',
            line: { color: '#e74c3c', width: 2 },
            marker: {
                size: 5,
                color: donnees.map((d) => (d.anomalie ? '#c0392b' : '#e74c3c')),
            },
        },
        {
            x: dates,
            y: donnees.map((d) => d.valeur_corrigee),
            type: 'scatter',
            mode: 'lines',
            name: 'Valeurs corrigées',
            line: { color: '#27ae60', width: 2 },
        },
    ];

    const plotLayout = {
        margin: { l: 50, r: 20, t: 30, b: 50 },
        showlegend: true,
        legend: { orientation: 'h', y: -0.2 },
        xaxis: { type: 'date', title: 'Date / Heure' },
        yaxis: { title: capteurInfo.unite },
        paper_bgcolor: 'rgba(0,0,0,0)',
        plot_bgcolor: '#fafafa',
        hovermode: 'x unified',
    };

    return (
        <>
            <div className={S.visualSection}>
                <div className={S.sectionHeader}>
                    <h3>Affichage graphique</h3>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div className={S.legend}>
                            <span className={S.legendItem}>
                                <span className={S.legendDot} style={{ background: '#e74c3c' }} />
                                Brutes
                            </span>
                            <span className={S.legendItem}>
                                <span className={S.legendDot} style={{ background: '#27ae60' }} />
                                Corrigées
                            </span>
                        </div>
                        <select
                            className={S.capteurSelect}
                            value={capteurActif}
                            onChange={(e) => {
                                cancelEdit();
                                setCapteurActif(e.target.value);
                            }}
                        >
                            {mockCapteurs.map((c) => (
                                <option key={c.id} value={c.id}>
                                    {c.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className={S.plotContainer}>
                    <BibliothequePlotly
                        data={plotData}
                        layout={plotLayout}
                        dimensionWidth="100%"
                        dimensionHeight={280}
                        minimaliste
                    />
                </div>
            </div>

            <div className={S.visualSection}>
                <div className={S.sectionHeader}>
                    <h3>
                        Liste des données — {donnees.length} mesures — {capteurInfo.label}
                    </h3>
                    <span style={{ fontSize: 12, color: '#888' }}>
                        {donnees.filter((d) => d.anomalie).length} anomalie(s) détectée(s)
                    </span>
                </div>
                <div className={S.tableWrapper}>
                    <table className={S.dataTable}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Date / Heure</th>
                                <th>Capteur</th>
                                <th>Valeur brute</th>
                                <th>Valeur corrigée</th>
                                <th>Statut</th>
                                <th>Commentaire</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {donnees.map((d) =>
                                editId === d.id ? (
                                    <tr key={d.id} className={S.rowEditing}>
                                        <td>{d.id}</td>
                                        <td>{d.date.toLocaleString('fr-FR')}</td>
                                        <td>{d.capteur}</td>
                                        <td>
                                            <input
                                                type="number"
                                                className={S.inputCorrection}
                                                step="0.1"
                                                value={editValues.valeur_brute}
                                                onChange={(e) =>
                                                    setEditValues((p) => ({ ...p, valeur_brute: e.target.value }))
                                                }
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                className={S.inputCorrection}
                                                step="0.1"
                                                value={editValues.valeur_corrigee}
                                                onChange={(e) =>
                                                    setEditValues((p) => ({ ...p, valeur_corrigee: e.target.value }))
                                                }
                                            />
                                        </td>
                                        <td>
                                            <span className={S.badgeOk}>OK</span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className={S.inputCommentaire}
                                                value={editValues.commentaire}
                                                onChange={(e) =>
                                                    setEditValues((p) => ({ ...p, commentaire: e.target.value }))
                                                }
                                                placeholder="Commentaire…"
                                            />
                                        </td>
                                        <td>
                                            <span style={{ display: 'flex', gap: 4 }}>
                                                <button className={S.btnAppliquer} onClick={() => saveEdit(d.id)}>
                                                    ✓
                                                </button>
                                                <button
                                                    className={S.btnAnnuler}
                                                    style={{ padding: '3px 8px', fontSize: 11 }}
                                                    onClick={cancelEdit}
                                                >
                                                    ✕
                                                </button>
                                            </span>
                                        </td>
                                    </tr>
                                ) : (
                                    <tr key={d.id} className={d.anomalie ? S.rowAnomalie : ''}>
                                        <td>{d.id}</td>
                                        <td>{d.date.toLocaleString('fr-FR')}</td>
                                        <td>{d.capteur}</td>
                                        <td>{d.valeur_brute} {capteurInfo.unite}</td>
                                        <td>{d.valeur_corrigee} {capteurInfo.unite}</td>
                                        <td>
                                            {d.statut === 'ok' ? (
                                                <span className={S.badgeOk}>OK</span>
                                            ) : (
                                                <span className={S.badgeErr}>Erreur</span>
                                            )}
                                        </td>
                                        <td>{d.commentaire}</td>
                                        <td>
                                            <button className={S.btnEdit} onClick={() => startEdit(d)}>
                                                ✏
                                            </button>
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default VisualisationTab;
